import React, {Component} from 'react';
import Breadcrumb from "../common/breadcrumb";

class TermsOfService extends Component {

    constructor (props) {
        super (props)
    }

    render (){

        return (
            <div>
                <Breadcrumb title={'Términos de Servicio'}/>

                <section className="about-page section-b-space">
                    <div className="container">
                        <div className="row">
                            <div className="col-sm-12">
                                <p><em>Última actualización: 16 de julio de 2026</em></p>

                                <p>Al utilizar la aplicación y los servicios de <strong>Wewith</strong> ("la App",
                                    "nosotros"), aceptas los siguientes términos.</p>

                                <h4>1. Uso del servicio</h4>
                                <p>La App permite a los usuarios realizar pedidos y coordinar entregas. El usuario se
                                    compromete a proporcionar información veraz y a utilizar el servicio de forma
                                    lícita.</p>

                                <h4>2. Cuentas y comunicación</h4>
                                <p>Para brindar el servicio, podemos comunicarnos contigo a través de WhatsApp u otros
                                    canales que hayas autorizado, incluyendo notificaciones sobre el estado de tus
                                    pedidos.</p>

                                <h4>3. Pedidos y entregas</h4>
                                <p>Los tiempos de entrega y disponibilidad de productos pueden variar según la zona y
                                    la operación logística. Nos reservamos el derecho de rechazar o cancelar pedidos
                                    por causas justificadas (por ejemplo, falta de stock o datos incorrectos).</p>

                                <h4>4. Propiedad</h4>
                                <p>Todo el contenido, marca y elementos de la App son propiedad de Wewith y no pueden
                                    ser reproducidos sin autorización.</p>

                                <h4>5. Limitación de responsabilidad</h4>
                                <p>Wewith no será responsable por daños indirectos derivados del uso de la App, en la
                                    medida permitida por la ley aplicable.</p>

                                <h4>6. Cambios en los términos</h4>
                                <p>Podemos actualizar estos Términos de Servicio en cualquier momento. Los cambios
                                    entrarán en vigencia al publicarse en esta página.</p>

                                <h4>7. Contacto</h4>
                                <p>Para consultas sobre estos Términos de Servicio, puedes escribirnos por WhatsApp al{' '}
                                    <a href="https://wa.me/51944847482" target="_blank" rel="noopener noreferrer">+51
                                        944 847 482</a>.</p>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        )
    }
}

export default TermsOfService
